export default __webpack_public_path__ + "static/media/glaze.1a573d5f.png";